
import { computed, defineComponent } from 'vue';
import { range } from 'JS/utilities/array';
import { useBreakpoints } from 'JS/composables/breakpoint';

export default defineComponent({
	name: 'AccountPagination',
	props: {
		page: {
			type: Number,
			required: true
		},
		totalPages: {
			type: Number,
			required: true
		}
	},
	emits: ['update:page'],
	setup(props) {
		const { isDesktop } = useBreakpoints();
		const maxPagesToShow = 7;

		const truncationNecessary = computed(() => props.totalPages > maxPagesToShow);
		const truncateStart = computed(() => truncationNecessary.value && props.page >= 5);
		const truncateEnd = computed(() => truncationNecessary.value && props.page <= (props.totalPages - 4));
		const columns = computed(() => Math.min(props.totalPages, maxPagesToShow));

		const middleRange = computed(() => {
			if (!truncationNecessary.value) {
				return range(2, props.totalPages - 1);
			}

			if (!truncateStart.value) {
				return range(2, 5);
			} else if (!truncateEnd.value) {
				return range(props.totalPages - 4, props.totalPages - 1);
			}

			return [props.page - 1, props.page, props.page + 1];
		});

		return {
			middleRange,
			columns,
			isDesktop,
			truncateStart,
			truncateEnd
		};
	}
});
